import { Separator } from '@/components/atoms/Separator';
import { Skeleton } from '@/components/atoms/Skeleton';
import CheckoutContainerDesktopFallback from '@/components/molecules/CheckoutContainer/Designs/Desktop/fallback';
import { breakpointDesktopDefault } from '@/hooks/useBreakpoint';
import { theme } from '@/styles/theme';
import { ReactNode } from 'react';

interface PaginaVendaDesktopFallbackProps {
  $fallbackConteudoDescritivo: ReactNode;
  $fallbackConteudoCheckout: ReactNode;
}

export default function PaginaVendaDesktopFallback(
  props: PaginaVendaDesktopFallbackProps,
) {
  const { $fallbackConteudoDescritivo, $fallbackConteudoCheckout } = props;
  return (
    <div>
      <Skeleton style={{ height: 32 }} />
      <div
        style={{
          ...breakpointDesktopDefault,
          width: '100%',
          minHeight: '60vh',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            flex: 1,
            paddingBottom: theme.spacing[5],
            gap: theme.spacing[7],
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1.5,
              minWidth: 0,
            }}
          >
            <Skeleton style={{ height: 280 }} />
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: theme.spacing[5],
                padding: `0 ${theme.spacing[7]}px`,
              }}
            >
              {$fallbackConteudoDescritivo}
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              minWidth: 0,
              paddingTop: theme.spacing[5],
              paddingRight: theme.spacing[6],
              gap: theme.spacing[4],
            }}
          >
            {$fallbackConteudoCheckout}
            <Separator $block={false} $orientation="horizontal" />
            <CheckoutContainerDesktopFallback />
          </div>
        </div>
      </div>
    </div>
  );
}
